import { CustomButton } from "Components/CustomButton";
import { ModalComponentV1 } from "Components/ModalComponentV1";
import styles from "./index.module.css";
import { useState } from "react";
import { CustomTextAreaV2 } from "Components/CustomTextAreaV2";
import infoBold from "assets/svg/infoBold.svg";

type Props = {
  isOpened: boolean;
  onClose: () => void;
  isView: boolean;
  onSend?: (comment: string) => Promise<void>;
  isCategoryChanged?: boolean;
  cancelCategoryChanges?: () => void;
  isLoading?: boolean;
  adminComment?: string;
  adminCommentTime?: string;
};

export const DeclineModal = (props: Props) => {
  const [comment, setComment] = useState("");
  const onSend = () => {
    if (comment.trim()) props.onSend(comment);
  };
  return (
    <ModalComponentV1
      isOpen={props.isOpened}
      onClose={props.onClose}
      title={props.isView ? "Declined Ad" : "Decline Ad"}
    >
      {props.isView ? (
        <div className={styles.wrapper}>
          <div className={styles.textWrapper}>
            <div>{props.adminCommentTime}</div>
            <p>{props.adminComment}</p>
          </div>
          <CustomButton sizeButton="large" typeButton="tertiary" onClick={props.onClose}>
            <span>Close</span>
          </CustomButton>
        </div>
      ) : (
        <div className={styles.wrapper}>
          <div className={styles.desctibe}>Please describe why the Ad cannot pass moderation</div>
          <div className={styles.textAreaWrapper}>
            <CustomTextAreaV2
              onChange={(v) => {
                console.log(v);
                setComment(v.target.value);
              }}
              additionalInfo={{
                limit: 150,
                title: "Helper",
              }}
              style={{ minHeight: 153, maxHeight: 300 }}
            />
          </div>
          {props.isCategoryChanged ? (
            <div className={styles.categoryHasChanged}>
              <div>
                <img src={infoBold} alt="info" /> <span>Сategory will be changed</span>
              </div>
              <CustomButton sizeButton="medium" typeButton="blackTextType" onClick={props?.cancelCategoryChanges}>
                Cancel
              </CustomButton>
            </div>
          ) : null}
          <div className={styles.btnsWrapper}>
            <CustomButton sizeButton="large" typeButton="tertiary" onClick={props.onClose}>
              Cancel
            </CustomButton>
            <CustomButton
              sizeButton="large"
              typeButton="primary"
              onClick={onSend}
              disabled={!comment.trim()}
              loading={props.isLoading}
            >
              Send
            </CustomButton>
          </div>
        </div>
      )}
    </ModalComponentV1>
  );
};
